module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226724607_05_ack#ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226724607_06_int#int"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226724607_07_pt1#pt1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1")]), _vm._v(". Martianus Capella, Remigius of Auxerre, William of Malmesbury")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226724607_08_ch1#ch1"
    }
  }, [_vm._v("1.  Martianus Capella, "), _c('em', [_vm._v("De nuptiis Philologiae et Mercurii")]), _vm._v(": A Brother to Hermaphroditus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226724607_09_ch2#ch2"
    }
  }, [_vm._v("2.  Martianus Capella, "), _c('em', [_vm._v("De nuptiis Philologiae et Mercurii")]), _vm._v("; Remigius of Auxerre, "), _c('em', [_vm._v("Commentum in Martianum Capellam")]), _vm._v(": Venus Rediviva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_10_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  William of Malmesbury, "), _c('em', [_vm._v("Gesta regum Anglorum")]), _vm._v(": Empowering Remnants of Ancient Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_11_pt2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2")]), _vm._v(". Alain de Lille: "), _c('em', [_vm._v("De planctu Naturae")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_12_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Alain de Lille, "), _c('em', [_vm._v("De planctu Naturae")]), _vm._v(": The Orthography of Venus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_13_ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Alain de Lille, "), _c('em', [_vm._v("De planctu Naturae")]), _vm._v(": The Vulgar Whorehouses of the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_14_ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Alain de Lille, "), _c('em', [_vm._v("De planctu Naturae")]), _vm._v(": Varied Colors of Venereal Discourse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_15_pt3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 3")]), _vm._v(". Guillaume de Lorris and Jean de Meun: "), _c('em', [_vm._v("Le Roman de la Rose")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_16_ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Guillaume de Lorris and Jean de Meun, "), _c('em', [_vm._v("Le Roman de la Rose")]), _vm._v(": The Garden of Unhallowed Delights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_17_ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  Jean de Meun, "), _c('em', [_vm._v("Le Roman de la Rose")]), _vm._v(": Unrefined Reason")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_18_ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Jean de Meun, "), _c('em', [_vm._v("Le Roman de la Rose")]), _vm._v(": Bele a coilles")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_19_con#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Conclusion: Never Mind the Relics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_21_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_20_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226724607_21_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1e3ac5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226724607_04_toc.vue
// module id = 63
// module chunks = 0